import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ActionErrorAlert,
  ActionSuccessAlert,
  AlertMetadata,
  AlertModelBase,
  CustomAlert,
  LoadingAlert,
  TextAlert,
  TryAgainActionErrorAlert,
  UndoAlert,
} from '../../models';
import { AlertStoreService } from '../../services/alert-store/alert-store.service';
import { HtmlSanitizer } from '@anecdotes/utils';

@Component({
  selector: 'app-alert-host',
  templateUrl: './alert-host.component.html',
  animations: [
    trigger('expandCollapse', [
      transition(':leave', [
        style({ width: '*', overflow: 'hidden' }), // initial
        animate('0.1s', style({ width: '0px' })), // final
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertHostComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex flex-col items-center gap-2 pointer-events-none';

  alertsMetada$: Observable<AlertMetadata[]>;

  constructor(private alertStore: AlertStoreService, private htmlSanitizer: HtmlSanitizer) {}

  ngOnInit(): void {
    this.alertsMetada$ = this.alertStore.getSortedAlerts();
  }

  removeAlert(alertId: string): void {
    this.alertStore.removeAlertAction(alertId);
  }

  getCustomAlert(alert: AlertModelBase): CustomAlert {
    return <CustomAlert>alert;
  }

  getTextAlert(alert: AlertModelBase): TextAlert {
    return <TextAlert>alert;
  }

  getActionErrorAlert(alert: AlertModelBase): ActionErrorAlert {
    return <ActionErrorAlert>alert;
  }

  getTryAgainActionErrorAlert(alert: AlertModelBase): TryAgainActionErrorAlert {
    return <TryAgainActionErrorAlert>alert;
  }

  getUndoAlert(alert: AlertModelBase): UndoAlert {
    return <UndoAlert>alert;
  }

  getLoadingAlert(alert: AlertModelBase): LoadingAlert {
    return <LoadingAlert>alert;
  }

  getActionSuccessAlert(alert: AlertModelBase): ActionSuccessAlert {
    return <ActionSuccessAlert>alert;
  }

  sanitizeRichText(input: string): string {
    return this.htmlSanitizer.sanitizeRichText(input);
  }
}
